<template>
    <modal-layout prevent-backdrop-click>
        <div class="mx-auto flex w-full max-w-xl flex-col items-center">
            <div class="mt-8 flex size-[72px] flex-row items-center justify-center rounded-full shadow-lg">
                <CIcon class="size-16 text-[#0da947]" name="checkmark" />
            </div>
            <p class="my-8 text-center text-2xl font-medium">Dobrovoľnícka príležitosť / projekt bol vytvorený</p>

            <OrganizationVolunteeringGuidance
                class="w-full"
                :items="organizationVolunteerPublishTips"
                title="Tipy, ako nájsť dobrovoľníka rýchlejšie"
            />

            <div class="mt-6 w-full space-y-4">
                <div>
                    <p class="mb-2 text-sm font-medium text-gray-800 dark:text-txt-headings">Link na zdieľanie ponuky</p>
                    <CCopyLink :shared-url="url" />
                </div>

                <CButton
                    full
                    target="_blank"
                    :to="{ name: 'dobrovolnictvo-dobrovolnici' }"
                    variant="primary"
                >
                    Pozrieť dobrovoľníkov
                </CButton>

                <CButton full variant="primary-150" @click="emit('close')">
                    Pokračovať na ponuku
                </CButton>
            </div>
        </div>
    </modal-layout>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import OrganizationVolunteeringGuidance from '@/components/projects/OrganizationVolunteeringGuidance.vue'
import CButton from '@/components/ui/CButton.vue'
import CCopyLink from '@/components/ui/CCopyLink.vue'
import CIcon from '@/components/ui/CIcon.vue'
import { organizationVolunteerPublishTips } from '@/data/organization-volunteering-onboarding'

defineProps<{
    id: string
    title: string
    url: string
}>()

const emit = defineEmits<{
    (e: 'close', route?: RouteLocationRaw): void
}>()
</script>
